
import { defineComponent } from 'vue'
import { formatDate, parseISODate } from '~/utils/date'
export default defineComponent({
  name: 'BillingAlertPastDue',
  props: {
    planName: {
      type: String,
      required: true
    },
    dueDate: {
      type: String,
      required: true
    }
  },
  methods: {
    formatDate,
    parseISODate
  }
})
